import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import { getButtonClass } from '../../../../components/popup/popupUtils';
import { sanitizeHtml } from '../../../../assets/utils/comm/sanitize';

/**
 * 텍스트 영역 팝업 컴포넌트
 * textarea 입력이 필요한 팝업
 */
const TextareaPopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const [textareaValue, setTextareaValue] = useState('');
  const [validated, setValidated] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (config?.initialData?.value) {
      setTextareaValue(config.initialData.value);
    }
    setValidated(false);
  }, [config?.initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      setValidated(true);
      return;
    }
    onClose(true, { value: textareaValue });
  };

  const handleLeftButtonClick = () => {
    onClose(false);
  };

  const handleRightButtonClick = () => {
    const form = textareaRef.current?.closest('form');
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <PopupWrapper
      config={config}
      onClose={onClose}
      displayType={config?.displayType || 'modal'}
      className="popup-textarea"
    >
      <div className="main-popup-body popup-textarea">
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(config?.content || ''),
          }}
        />
        <div className="main-popup-textarea">
          <form
            ref={textareaRef}
            className={`needs-validation ${validated ? 'was-validated' : ''}`}
            noValidate
            onSubmit={handleSubmit}
          >
            <div className="single-input-item">
              <label htmlFor="popup-textarea-input">
                {config?.label || t('popup.common.contentLabel')}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <textarea
                id="popup-textarea-input"
                className="form-control"
                required
                value={textareaValue}
                onChange={(e) => setTextareaValue(e.target.value)}
                style={{ marginBottom: '0px !important' }}
              />
              <div className="invalid-feedback">{t('popup.common.requiredField')}</div>
            </div>
          </form>
        </div>
      </div>
      <div className="main-popup-footer d-flex justify-content-between">
        {config?.leftButton && (
          <button
            type="button"
            className={`btn main-popup-left-btn ${getButtonClass(config.leftButton.color || 'btn-secondary')}`}
            onClick={handleLeftButtonClick}
          >
            {config.leftButton.text || t('popup.common.cancel')}
          </button>
        )}
        {config?.rightButton && (
          <button
            type="button"
            className={`btn main-popup-right-btn ${getButtonClass(config.rightButton.color || 'btn-primary')}`}
            onClick={handleRightButtonClick}
          >
            {config.rightButton.text || t('popup.common.confirm')}
          </button>
        )}
      </div>
    </PopupWrapper>
  );
};

export default TextareaPopup;

